import { closeSmallIconSvg } from 'constants/svg-assets';

/**
 * @classdesc The `Pill` class encapsulates the behavior and properties of a pill in the popular searches pills section.
 */
export default class Pill {
  /**
   * @param {string} params.name The unique identifier for the pill.
   * @param {string} params.text The text to be displayed for the pill.
   * @param {boolean} params.isEnabled The boolean to determine whether the pill is disabled or not.
   */
  constructor({ name, text, isEnabled, isActive }) {
    const parser = new DOMParser();
    this.name = name;
    this.text = text;
    this.id = `chk_${this.name}`;
    this.isEnabled = isEnabled;
    this.isActive = isActive;
    this.closeSmallIconSvgElement = parser.parseFromString(closeSmallIconSvg, 'image/svg+xml').documentElement;
  }

  /**
   * Generates the HTML representation of the pill based on constructed values.
   * @returns {string} The HTML string for the pill.
   */
  getHtml() {
    return `<li class="nhs-c-popular-search__pill-container">
              <input id="${this.id}"
                  hidden
                  class="nhs-c-popular-search__pill-checkbox"
                  name="popularSearchesPill" 
                  type="checkbox"
                  autocomplete="off"
                  value="${this.name}" 
                  data-popular-searches-pill-type="${this.name}" 
                  data-qa-popular-pill="${this.name}"
                  ${!this.isEnabled ? 'disabled' : ''}>
              <label class='nhs-c-popular-search__pill nhs-c-popular-search__pill--medium-regular nhs-c-popular-search__pill--height-760' for="${
                this.id
              }" data-qa="${this.name}">
                ${this.text}
                ${this.getClose()}
              </label>
            </li>`;
  }

  getClose() {
    if (this.isActive) {
      return `<span class='nhs-c-popular-search__pill-icon--close'>
                ${this.closeSmallIconSvgElement.cloneNode(true).outerHTML}
              </span>`;
    }

    return '';
  }

  /**
   * Retrieves the HTML element associated with the pill.
   * @returns {HTMLElement|null} The pill's HTML element or null if not found.
   */
  getNode() {
    return document?.getElementById(this.id);
  }

  /**
   * Checks the pill by adding the 'active' class.
   */
  check() {
    const pillNode = this.getNode();
    if (pillNode) {
      pillNode.checked = true;
    }
  }

  /**
   * Unchecks the pill by removing the 'active' class.
   */
  uncheck() {
    const pillNode = this.getNode();
    if (pillNode) {
      pillNode.checked = false;
    }
  }
}
